import Vue from 'vue'
import Vuex from 'vuex'

// Import modules
import messages from './modules/messages'
import orderSync from './modules/orderSync'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    messages,
    orderSync
  },
  
  state: {
    user: null,
    isAuthenticated: false
  },
  
  mutations: {
    SET_USER(state, user) {
      state.user = user
      state.isAuthenticated = !!user
    }
  },
  
  actions: {
    setUser({ commit }, user) {
      commit('SET_USER', user)
    }
  },
  
  getters: {
    currentUser: state => state.user,
    isAuthenticated: state => state.isAuthenticated,
    isAdmin: state => state.user?.role == 'admin' || false
  }
})